import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { MaterialService } from './material.service';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { LogAction, Paginator } from '../model/logAction.model';

@Injectable()
export class LogActionService extends KiwixiService {
    private readonly API_URL = `${environment.server}log-actions/`;

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    /**
     * Récupère la liste des LogActions avec filtres
     */
    getObservableLogActions(params?: HttpParams): Observable<Paginator<LogAction>> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.get<Paginator<LogAction>>(this.API_URL, { headers, params }).pipe(
            catchError(this.handleErrorObservable<Paginator<LogAction>>('getObservableLogActions'))
        );
    }

    /**
     * Récupère les LogActions par URL (pagination)
     */
    getObservableLogActionsByUrl(url: string): Observable<Paginator<LogAction>> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.get<Paginator<LogAction>>(url, { headers }).pipe(
            catchError(this.handleErrorObservable<Paginator<LogAction>>('getObservableLogActionsByUrl'))
        );
    }

    /**
     * Récupère un LogAction par ID
     */
    getObservableLogAction(id: number): Observable<LogAction> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.get<LogAction>(`${this.API_URL}${id}/`, { headers }).pipe(
            catchError(this.handleErrorObservable<LogAction>('getObservableLogAction'))
        );
    }

    /**
     * Récupère les logs pour un Lilate spécifique
     * Utilise l'endpoint custom: /lilate_exams/<lilate_id>/logs
     */
    getObservableLogActionsByLilate(lilateId: number, params?: HttpParams): Observable<Paginator<LogAction>> {
        const headers = this.createHttpClientAuthorizationHeader();
        const url = `${environment.server}lilate_exams/${lilateId}/logs/`;
        return this._http.get<Paginator<LogAction>>(url, { headers, params }).pipe(
            catchError(this.handleErrorObservable<Paginator<LogAction>>('getObservableLogActionsByLilate'))
        );
    }

    /**
     * Historique des modifications (LogAction) pour un FlashLevel.
     * GET /api/v1/elates/<elate_id>/log-actions/
     */
    getObservableLogActionsByElate(elateId: number, params?: HttpParams): Observable<Paginator<LogAction>> {
        const headers = this.createHttpClientAuthorizationHeader();
        const url = `${environment.server}elates/${elateId}/log-actions/`;
        return this._http.get<Paginator<LogAction>>(url, { headers, params }).pipe(
            catchError(this.handleErrorObservable<Paginator<LogAction>>('getObservableLogActionsByElate'))
        );
    }

    /**
     * Historique des modifications (LogAction) pour une formation.
     * GET /api/v1/formations/<formation_id>/log-actions/
     */
    getObservableLogActionsByFormation(formationId: number, params?: HttpParams): Observable<Paginator<LogAction>> {
        const headers = this.createHttpClientAuthorizationHeader();
        const url = `${environment.server}formations/${formationId}/log-actions/`;
        return this._http.get<Paginator<LogAction>>(url, { headers, params }).pipe(
            catchError(this.handleErrorObservable<Paginator<LogAction>>('getObservableLogActionsByFormation'))
        );
    }
}
